import React from 'react';
import { useTranslation } from 'react-i18next';

import Footer from '@/components/footer';
import Header from '@/components/header';

const PrivacyPolicy = (): React.ReactElement => {
  const { t } = useTranslation();
  // Privacy Policy data for mapping
  const pp = [
    {
      title: t('privacy-policy.items.0.title'),
      content: t('privacy-policy.items.0.content'),
    },
    {
      title: t('privacy-policy.items.1.title'),
      content: t('privacy-policy.items.1.content'),
    },
    {
      title: t('privacy-policy.items.2.title'),
      content: t('privacy-policy.items.2.content'),
    },
    {
      title: t('privacy-policy.items.3.title'),
      content: t('privacy-policy.items.3.content'),
    },
    {
      title: t('privacy-policy.items.4.title'),
      content: t('privacy-policy.items.4.content'),
    },
    {
      title: t('privacy-policy.items.5.title'),
      content: t('privacy-policy.items.5.content'),
    },
    {
      title: t('privacy-policy.items.6.title'),
      content: t('privacy-policy.items.6.content'),
    },
    {
      title: t('privacy-policy.items.7.title'),
      content: t('privacy-policy.items.7.content'),
    },
    {
      title: t('privacy-policy.items.8.title'),
      content: t('privacy-policy.items.8.content'),
    },
    {
      title: t('privacy-policy.items.9.title'),
      content: t('privacy-policy.items.9.content'),
    },
  ];

  return (
    <>
      <Header />
      <section className="flex flex-col items-center justify-center gap-6 py-8 px-8 md:px-20 w-full">
        <h2 className="text-4xl md:text-5xl font-bold text-center">
          {t('privacy-policy.title')}
        </h2>
        <p className="text-center text-grayish text-sm">
          {t('privacy-policy.version', { date: '29/10/2025', version: '1.0' })}
        </p>
        <ol className="list-decimal list-inside max-w-4xl space-y-4 text-grayish text-left">
          {pp.map((term, index) => (
            <li key={index} className="space-y-2 font-semibold">
              {term.title}
              <p className="font-normal text-sm whitespace-pre-line">
                {term.content}
              </p>
            </li>
          ))}
        </ol>
      </section>
      <Footer />
    </>
  );
};

export default PrivacyPolicy;
